import { Theme } from '@mui/material/styles';
import { createAppStyles } from '@infygen/theme';
import { getBaseStyles } from './DataTable.styles.shared';

export const useStyles = createAppStyles((theme: Theme) => getBaseStyles(theme), {
  admin: {
    toolbar: {},
    toolbarSelected: {},
    title: {},
    searchField: {},
    tableContainer: {},
    tableCell: {},
    clickableRow: {},
    defaultRow: {},
    highlightedRow: {},
    emptyCell: {},
  },
  user: {
    toolbar: {},
    toolbarSelected: {},
    title: {},
    searchField: {},
    tableContainer: {},
    tableCell: {},
    clickableRow: {},
    defaultRow: {},
    highlightedRow: {},
    emptyCell: {},
  },
  consultant: {
    toolbar: {},
    toolbarSelected: {},
    title: {},
    searchField: {},
    tableContainer: {},
    tableCell: {},
    clickableRow: {},
    defaultRow: {},
    highlightedRow: {},
    emptyCell: {},
  },
});
